import React from 'react';

export const PaymentCardIcons = ({ className = "w-full", compact = false }) => {
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      {/* Mastercard */}
      <div className="bg-white px-2 py-1 rounded-md border border-slate-200 shadow-2xs flex items-center justify-center h-6 shrink-0" title="Mastercard">
        <svg viewBox="0 0 36 24" className="h-4 w-auto" fill="none">
          <circle cx="14" cy="12" r="7" fill="#EB001B" />
          <circle cx="22" cy="12" r="7" fill="#F79E1B" fillOpacity="0.85" />
        </svg>
      </div>

      {/* Visa */}
      <div className="bg-white px-2 py-1 rounded-md border border-slate-200 shadow-2xs flex items-center justify-center h-6 shrink-0" title="Visa">
        <svg viewBox="0 0 36 24" className="h-3.5 w-auto" fill="none">
          <text x="3" y="17" fill="#1A1F71" fontFamily="sans-serif" fontWeight="900" fontSize="13" fontStyle="italic" letterSpacing="0.05em">
            VISA
          </text>
        </svg>
      </div>

      {/* Verve */}
      <div className="bg-white px-2 py-1 rounded-md border border-slate-200 shadow-2xs flex items-center justify-center h-6 shrink-0" title="Verve Card (Nigeria)">
        <span className="font-sans font-black text-[10px] text-[#00425F] italic tracking-tight">
          verve
        </span>
      </div>

      {!compact && (
        <>
          {/* Bank Transfer / NIBSS Instant Payment */}
          <div className="bg-white px-2 py-1 rounded-md border border-slate-200 shadow-2xs flex items-center justify-center h-6 space-x-1 shrink-0" title="Direct Bank Transfer / NIP">
            <div className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
            <span className="font-mono font-bold text-[8.5px] text-slate-700">
              Bank Transfer
            </span>
          </div>

          {/* USSD */}
          <div className="bg-white px-2 py-1 rounded-md border border-slate-200 shadow-2xs flex items-center justify-center h-6 shrink-0" title="USSD Code Checkout (*737#, *894#, *966#)">
            <span className="font-mono font-bold text-[8.5px] text-[#0B2644]">
              *USSD#
            </span>
          </div>

          {/* Paystack Secured Badge */}
          <div className="bg-[#001428] text-white px-2 py-1 rounded-md shadow-2xs flex items-center space-x-1 h-6 border border-[#00C3F7]/40 shrink-0">
            <span className="w-1.5 h-1.5 rounded-full bg-[#00C3F7]" />
            <span className="font-sans font-bold text-[8.5px] text-[#00C3F7]">
              Paystack Verified
            </span>
          </div>
        </>
      )}
    </div>
  );
};
